(() => {
  const copper = '#B87355';

  const apply = (root = document) => {
    root.querySelectorAll?.('.product-form__input--color label').forEach((label) => {
      if ((label.textContent || '').trim().toLowerCase() === 'brushed copper') {
        label.style.setProperty('--option-color', copper);
        label.style.removeProperty('--option-color-image');
      }
    });

    root.querySelectorAll?.('.product-card-swatch').forEach((swatch) => {
      const name = swatch.querySelector('.visually-hidden')?.textContent?.trim().toLowerCase();
      if (name === 'brushed copper') {
        swatch.style.setProperty('--option-color', copper);
        swatch.style.removeProperty('--option-color-image');
      }
    });
  };

  const start = () => {
    apply(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) apply(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
